/**
 * Blob media URL helper. Mirrors `cmsMediaUrl()` in `lib/cms.ts`.
 *
 * All non-CMS media (videos, hero imagery, marketing assets) lives in the
 * `marketing-site-blob` Vercel Blob store. This helper produces the public
 * URL from a relative path stored in code (e.g. `"/homepage/hero.jpeg"`),
 * reading the store's public base URL from `NEXT_PUBLIC_BLOB_BASE_URL`.
 *
 * For CMS-managed media (articles, authors), use `cmsMediaUrl()` instead —
 * those flow through Payload and may live on a different Blob store.
 *
 * Behavior when env is unset (lint scripts, type-check, etc. — anywhere
 * `data/*.ts` is imported without runtime env): returns the path unchanged
 * so module evaluation succeeds. Production builds always have the env set
 * (verified in next.config.ts at build time and in the runtime env on
 * Vercel), so the fallback is never hit at request time.
 *
 * For the upload + deletion workflow see `.claude/skills/media-handling/SKILL.md`.
 */
export function blobMediaUrl(path: string): string {
  if (!path) return ""
  if (path.startsWith("http://") || path.startsWith("https://")) return path
  const base = process.env.NEXT_PUBLIC_BLOB_BASE_URL
  if (!base) return path
  const trimmedBase = base.replace(/\/$/, "")
  const trimmedPath = path.replace(/^\//, "")
  return `${trimmedBase}/${trimmedPath}`
}
